import DbManagerService from '@/services/benchmarks/DbManagerService.js';
import { getUrlParameter, HandleCookies } from '@/utils';
import router from '@/router/router';

export class Benchmarks {
  #user

  #company

  #props = {
    benchmarksList: [],
    hasBenchmarksExpired: false,
    pageGroups: [],
    isValidAccessToBenchmarks: false,
  };

  constructor(user, company) {
    this.#user = user;
    this.#company = company;
  }

  get hasBenchmarksExpired() {
    return this.#props.hasBenchmarksExpired;
  }

  get benchmarksList() {
    return this.#props.benchmarksList;
  }

  get pageGroups() {
    return this.#props.pageGroups;
  }

  get isValidAccessToBenchmarks() {
    return this.#props.isValidAccessToBenchmarks;
  }

  get userGroup() {
    return this.#company.id;
  }

  get benchmarksId() {
    return this.#props.benchmarksList.length > 0 ? this.#props.benchmarksList[0].id : '';
  }

  isAdminUserGroup() {
    const adminUsergroupList = [5703116783878144, 4816908371099648];

    return adminUsergroupList.includes(this.userGroup);
  }

  async fetchBenchmarksList(userGroup) {
    const benchmarksIdParameter = getUrlParameter('benchmarks_id');
    const { data: benchmarksFromPlan } = await DbManagerService.getPlans({}, userGroup);

    if (!benchmarksIdParameter) {
      this.#props.benchmarksList = benchmarksFromPlan;
      return;
    }

    const benchmarksIdParameterAsList = [{ id: benchmarksIdParameter }];

    if (this.isAdminUserGroup()) {
      this.#props.benchmarksList = benchmarksIdParameterAsList;
      return;
    }

    const benchmarksIdParameterInPlans = benchmarksFromPlan
      .some(bench => bench.id === benchmarksIdParameter);

    this.#props.benchmarksList = benchmarksIdParameterInPlans
      ? benchmarksIdParameterAsList
      : benchmarksFromPlan;
  }

  validateBenchmarksList() {
    if (this.#props.benchmarksList.length) return;

    const url = 'https://conteudos.stilingue.com.br/stilingue-benchmarks';
    window.location.assign(url);

    return url;
  }

  validateBenchmarksExpired() {
    const hasBenchmarksExpired = this.#props.benchmarksList.some(b => b.expired === true);
    this.#props.hasBenchmarksExpired = hasBenchmarksExpired;

    if (hasBenchmarksExpired) {
      router.push({ name: 'purchase' }).catch(() => null);
    }
  }

  async fetchPageGroups(benchmarksId) {
    const { data } = await DbManagerService.getPageGroups({}, benchmarksId);
    const pageGroupsOrdered = data.sort((a, b) => (a.name > b.name ? 1 : -1));

    this.#props.pageGroups = pageGroupsOrdered;
  }

  configureCookies() {
    const configToCookie = {
      expires: 3 / 24,
      sameSite: 'None',
      Secure: true,
    };

    HandleCookies.setCookies({
      name: 'plan-id',
      value: this.userGroup,
      config: configToCookie,
    });

    HandleCookies.setCookies({
      name: 'benchmarks-id',
      value: this.benchmarksId,
      config: configToCookie,
    });
  }

  validateAccessToBenchmarks() {
    if (!this.benchmarksId) {
      this.#props.isValidAccessToBenchmarks = false;

      router.push({ name: 'access-denied' });

      return;
    }

    this.#props.isValidAccessToBenchmarks = true;
  }

  sendToHomePage() {
    router.push({
      name: 'home',
      query: { plan_id: this.userGroup, benchmarks_id: this.benchmarksId },
    }).catch(() => null);
  }

  async execute() {
    await this.fetchBenchmarksList(this.userGroup);
    this.validateBenchmarksList();
    this.validateBenchmarksExpired();

    if (this.#props.hasBenchmarksExpired) return this;

    this.validateAccessToBenchmarks();

    if (!this.#props.isValidAccessToBenchmarks) return this;

    await this.fetchPageGroups(this.benchmarksId);
    this.configureCookies();
    this.sendToHomePage();

    return this;
  }
}
